/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-24 VN — WEB-20261024-suzitee-upload-progress (v2)
   Đã làm: ô "Processing your photo… %" + thanh tiến độ (kiểu Wanderprints) thay dòng cam "Just wait a little bit..." khi:
   (1) khách upload ảnh (Customily Image Upload, gồm cả bước xoá nền), (2) bấm "Create crossword".
   v2: lúc đang xử lý ảnh → khoá (làm mờ) nút Replace / ✕ của Customily + chặn bấm; nút X trong ô để HUỶ upload đang chạy
   — huỷ thật bằng cơ chế huỷ có sẵn của Customily (engraver.engraverImage._abortUpload: AbortController của lệnh upload S3
   + xoá nền), xong gọi đúng hàm "xoá ảnh" của Customily (ImageUpload.handleRemoveImage) → về trạng thái chưa upload.
   Không tìm thấy 2 hàm đó (Customily đổi code) → KHÔNG hiện nút X, phần còn lại chạy như v1.
   Crossword: khoá ô nhập tên trong lúc tạo; không có nút X (Customily không có lệnh huỷ crossword, tạo xong ~2–5 giây).
   Nhiều ô upload trên 1 SP: mỗi ô có tiến độ riêng.
   Xong → ô GIỮ LẠI ở trạng thái xanh "Photo ready ✓ 100% · Ready to Preview & Edit" (thay dòng xanh của LinhNN, như Wanderprints giữ
   khung ảnh) để phần dưới không bị kéo lên lại (giảm CLS); ảnh bị xoá (dòng trạng thái LinhNN mất) → gỡ ô.
   % là ƯỚC LƯỢNG theo thời gian (không có % thật), mốc thật duy nhất: ảnh gốc lên S3 xong (Performance API, chỉ đọc).
   100% khi dòng xanh "Ready to Preview & Edit" (Customily Developer JS của LinhNN) xuất hiện — script này chỉ đọc dòng đó.
   SP có popup AI Processing riêng (window.linhnnCustomilyAIProcessingEnabled) → bỏ qua phần ảnh, không hiện 2 lần.
   Không sửa file vendor, không đổi setting Customily. Tắt khẩn: ?szup=0 hoặc window.__szUpOff=1. */
(function () {
  'use strict';
  if (window.__szUP) return;
  var UP = window.__szUP = { runs: 0, cancels: 0, v: 2 };
  try { if (/[?&]szup=0\b/.test(location.search) || window.__szUpOff) { UP.off = 1; return; } } catch (e) {}

  var CAP = 95, SLOW_MS = 45000;
  var CFG = {
    photo: { title: 'Processing your photo…', tauUp: 7000, tauAi: 4000, sel: 'linhnn-uploaded-status' },
    cw: { title: 'Creating your crossword…', tauUp: 2500, sel: 'linhnn-crossword-status' }
  };
  var css = '.szup{display:flex;width:100%;box-sizing:border-box;align-items:center;gap:12px;margin:8px 0 4px;padding:10px 12px;border:1px dashed #f5a35c;border-radius:10px;background:#fff8f1;font-family:inherit;line-height:1.3}' +
    '.szup-ic{flex:0 0 34px;width:34px;height:34px;position:relative}' +
    '.szup-ic:before{content:"";position:absolute;inset:0;border-radius:50%;border:3px solid #ffe0c2;border-top-color:#ff7a00;animation:szup-spin .9s linear infinite;z-index:1}' +
    '.szup-ic svg{position:absolute;left:8px;top:8px;width:18px;height:18px}' +
    '.szup-ic img{position:absolute;left:4px;top:4px;width:26px;height:26px;border-radius:50%;object-fit:cover}' +
    '.szup-b{flex:1;min-width:0}' +
    '.szup-t{font-size:14px;color:#333;font-weight:600}.szup-t b{color:#ff7a00;font-variant-numeric:tabular-nums}' +
    '.szup-s{font-size:12px;color:#777;margin-top:2px}' +
    '.szup-k{height:6px;border-radius:3px;background:#ffe0c2;margin-top:6px;overflow:hidden}' +
    '.szup-k i{display:block;height:100%;width:0;background:#ff7a00;border-radius:3px;transition:width .25s linear}' +
    '.szup-x{flex:0 0 36px;width:36px;height:36px;margin:-4px -6px -4px 0;padding:0;border:0;border-radius:50%;background:transparent;color:#888;font-size:22px;line-height:36px;text-align:center;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.szup-x:hover,.szup-x:focus-visible{background:#ffe9d6;color:#d35400;outline:0}' +
    '.szup.szup-done{border-color:#8fd19e;background:#f3fbf4}.szup.szup-done .szup-ic:before{animation:none;border-color:#2e9e44}.szup.szup-done .szup-k i{background:#2e9e44}.szup.szup-done .szup-t b{color:#2e9e44}' +
    '.szup.szup-cxl{border-color:#ccc;background:#f6f6f6}.szup.szup-cxl .szup-ic:before{animation:none;border-color:#ccc}.szup.szup-cxl .szup-k i{background:#bbb}' +
    '.linhnn-uploaded-status.szup-hide,.linhnn-crossword-status.szup-hide{display:none!important}' +
    '.szup-lock .customily-download-button,.szup-lock .cl_remove-image{opacity:.45!important;filter:grayscale(1);cursor:not-allowed!important;pointer-events:none!important}' +
    '.szup-lock textarea,.szup-lock input[type=text]{opacity:.6}' +
    '@keyframes szup-spin{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.szup-ic:before{animation:none}}';
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="#ff7a00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2-2a2 2 0 0 1-2-2a2 2 0 0 1-2 2m0-12a2 2 0 0 1 2 2a2 2 0 0 1 2-2a2 2 0 0 1-2-2a2 2 0 0 1-2 2m-7 12a6 6 0 0 1 6-6a6 6 0 0 1-6-6a6 6 0 0 1-6 6a6 6 0 0 1 6 6"/></svg>';

  function aiModalOn() { var v = window.linhnnCustomilyAIProcessingEnabled; return !!v && v !== '0' && v !== 'false'; }

  // Mốc thật duy nhất có được: ảnh gốc PUT lên S3 xong (URL ký có ?X-Amz). Chỉ đọc entry đã hoàn tất.
  var lastUpDone = 0;
  try {
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (e) { if (/js-lib-temp-images\/[^?]+\?X-Amz/i.test(e.name)) lastUpDone = performance.now(); });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}

  /* ---- móc vào Customily để huỷ (chỉ dùng hàm có sẵn của Customily, không vá code vendor) ---- */
  function engImg() {
    var e = window.engraver; if (!e) return null;
    if (e.engraverImage && e.engraverImage.queue instanceof Map && typeof e.engraverImage._abortUpload === 'function') return e.engraverImage;
    for (var k in e) { var v = e[k]; if (v && typeof v === 'object' && v.queue instanceof Map && typeof v._abortUpload === 'function') return v; }
    return null;
  }
  function uploadVm(el) { // component Vue "ImageUpload" của Customily (có option + handleRemoveImage)
    for (var n = el, i = 0; n && i < 8; n = n.parentElement, i++) {
      var vm = n.__vue__;
      if (vm && vm.option && vm.option.type === 'Image Upload' && typeof vm.handleRemoveImage === 'function') return vm;
    }
    return null;
  }
  function abortKeys(vm) {
    var ei = engImg(); if (!ei) return 0;
    var id = String(vm.option.file_upload_image_id || 1) + '-', n = 0;
    Array.from(ei.queue.keys()).forEach(function (k) { if (String(k).indexOf(id) === 0) { try { ei._abortUpload(k); n++; } catch (e) {} } });
    return n;
  }

  var runs = []; // tối đa vài phần tử (mỗi ô upload / crossword đang chạy 1 run)
  var dones = []; // ô đã xong đang giữ lại: { kind, host, el }
  function doneFor(host) { for (var i = 0; i < dones.length; i++) if (dones[i].host === host) return dones[i]; return null; }
  function undone(d) { var i = dones.indexOf(d); if (i > -1) dones.splice(i, 1); if (d.el.parentNode) d.el.parentNode.removeChild(d.el); }
  function runFor(host) { for (var i = 0; i < runs.length; i++) if (runs[i].host === host) return runs[i]; return null; }
  function drop(run) { var i = runs.indexOf(run); if (i > -1) runs.splice(i, 1); }

  function ensureCss() { if (!document.getElementById('szup-css')) { var st = document.createElement('style'); st.id = 'szup-css'; st.textContent = css; document.head.appendChild(st); } }

  function lock(run, on) {
    var c = run.lockEl; if (!c) return;
    if (on) c.classList.add('szup-lock'); else c.classList.remove('szup-lock');
    if (run.kind === 'cw' && run.fields) run.fields.forEach(function (f) { try { if (on) { f.el.readOnly = true; } else { f.el.readOnly = f.ro; } } catch (e) {} });
  }

  function start(kind, statusEl) {
    var host, anchor, lockEl;
    if (kind === 'photo') {
      host = statusEl.parentNode; if (!host) return;
      anchor = statusEl; lockEl = statusEl.closest('.customily-file-input') || host;
    } else {
      host = statusEl.closest('.customily_option'); if (!host) return;
      var btn = host.querySelector('.customily-dall-e-button'); if (!btn || !btn.parentNode) return;
      anchor = btn.parentNode; lockEl = host;
    }
    var old = runFor(host);
    // Customily/LinhNN có thể gắn lại dòng "Just wait" nhiều lần trong 1 lần chạy → giữ nguyên tiến độ, chỉ ẩn dòng mới
    if (old && !old.ended && old.el.isConnected) { statusEl.classList.add('szup-hide'); old.statusEl = statusEl; return; }
    if (old) stop(old);
    var dn = doneFor(host);
    ensureCss();
    var C = CFG[kind];
    var vm = kind === 'photo' ? uploadVm(statusEl) : null;
    var canCancel = !!(vm && engImg());
    var el = document.createElement('div');
    el.className = 'szup szup-' + kind; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<span class="szup-ic">' + ICON + '</span><div class="szup-b"><div class="szup-t">' + C.title + ' <b>0%</b></div><div class="szup-k"><i></i></div><div class="szup-s">Please keep this page open</div></div>' +
      (canCancel ? '<button type="button" class="szup-x" aria-label="Cancel upload" title="Cancel upload">&times;</button>' : '');
    // ảnh thu nhỏ của file khách vừa chọn (giống Wanderprints) — chỉ đọc file input, không đổi gì
    if (kind === 'photo') {
      try {
        var inp = lockEl.querySelector('input[type=file]'), f = inp && inp.files && inp.files[0];
        if (f && /^image\/(jpe?g|png|webp|gif|bmp)$/i.test(f.type) && window.URL && URL.createObjectURL) {
          var url = URL.createObjectURL(f), im = new Image(); im.alt = ''; im.src = url;
          im.onload = im.onerror = function () { try { URL.revokeObjectURL(url); } catch (e) {} };
          var ic = el.querySelector('.szup-ic'); ic.removeChild(ic.querySelector('svg')); ic.appendChild(im);
        }
      } catch (e) {}
    }
    statusEl.classList.add('szup-hide');
    if (dn && dn.el.parentNode) { dn.el.parentNode.insertBefore(el, dn.el); undone(dn); } // thay đúng chỗ, không nhảy layout
    else if (kind === 'photo') host.insertBefore(el, anchor.nextSibling);
    else anchor.parentNode.insertBefore(el, anchor.nextSibling);
    var run = { kind: kind, host: host, el: el, statusEl: statusEl, lockEl: lockEl, vm: vm, t0: performance.now() };
    if (kind === 'cw') run.fields = Array.prototype.map.call(host.querySelectorAll('textarea,input[type=text]'), function (x) { return { el: x, ro: x.readOnly }; });
    runs.push(run); UP.runs++;
    lock(run, true);
    var x = el.querySelector('.szup-x');
    if (x) x.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); cancel(run); });
    var aiT0 = 0, aiFrom = 0, p = 0, shown = -1;
    var pctEl = el.querySelector('b'), bar = el.querySelector('i'), sub = el.querySelector('.szup-s');
    run.timer = setInterval(function () {
      if (!el.isConnected) { stop(run); return; }
      var now = performance.now();
      if (kind === 'photo' && !aiT0 && lastUpDone > run.t0) { aiT0 = now; aiFrom = Math.max(p, 55); }
      var target = aiT0 ? aiFrom + (CAP - aiFrom) * (1 - Math.exp(-(now - aiT0) / C.tauAi))
                        : 3 + (88 - 3) * (1 - Math.exp(-(now - run.t0) / C.tauUp));
      p = Math.max(p, Math.min(CAP, target));
      var n = Math.floor(p);
      if (n !== shown) { shown = n; pctEl.textContent = n + '%'; bar.style.width = n + '%'; }
      if (aiT0 && sub.getAttribute('data-s') !== 'ai') { sub.setAttribute('data-s', 'ai'); sub.textContent = 'Uploaded ✓ — preparing your design'; }
      if (now - run.t0 > SLOW_MS && sub.getAttribute('data-s') !== 'slow') { sub.setAttribute('data-s', 'slow'); sub.textContent = 'Taking a bit longer than usual — almost there'; }
    }, 200);
  }

  function finish(host) {
    var run = runFor(host); if (!run || run.ended) return;
    if (run.cancelled) return; // dòng "Ready" sau khi huỷ → bỏ qua, cancel() tự dọn
    run.ended = 1; clearInterval(run.timer); drop(run); lock(run, false);
    var el = run.el;
    el.classList.add('szup-done');
    el.querySelector('.szup-t').innerHTML = (run.kind === 'cw' ? 'Crossword ready' : 'Photo ready') + ' <b>100%</b>';
    el.querySelector('i').style.width = '100%';
    el.querySelector('.szup-s').textContent = 'Ready to Preview & Edit';
    var x = el.querySelector('.szup-x'); if (x) x.parentNode.removeChild(x);
    el.setAttribute('aria-live', 'off');
    dones.push({ kind: run.kind, host: run.host, el: el });
    hideReady(run.host, run.kind);
  }
  function hideReady(host, kind) {
    Array.prototype.forEach.call(host.querySelectorAll('.' + CFG[kind].sel), function (s) { if (!s.classList.contains('szup-hide')) s.classList.add('szup-hide'); });
  }

  function stop(run, keepStatus) {
    if (!run) return;
    run.ended = 1; clearInterval(run.timer); drop(run); lock(run, false);
    if (run.el.parentNode) run.el.parentNode.removeChild(run.el);
    if (keepStatus && run.statusEl) run.statusEl.classList.remove('szup-hide');
  }

  // HUỶ: abort upload/xoá nền của Customily → chờ Customily nhả nút (loadingImage=false) → gọi hàm xoá ảnh của Customily
  function cancel(run) {
    if (run.cancelled || run.ended) return;
    run.cancelled = 1; UP.cancels++;
    clearInterval(run.timer);
    var el = run.el, vm = run.vm;
    el.classList.add('szup-cxl');
    el.querySelector('.szup-t').textContent = 'Cancelling upload…';
    el.querySelector('.szup-s').textContent = '';
    var x = el.querySelector('.szup-x'); if (x) x.disabled = true;
    var t0 = Date.now(), aborted = 0;
    (function tick() {
      try {
        if (vm.option.loadingImage) {
          aborted += abortKeys(vm); // upload chưa vào hàng đợi (đang đọc/nén file) → thử lại tới khi có
          if (Date.now() - t0 < 60000) { setTimeout(tick, 150); return; }
        }
        vm.handleRemoveImage(); // = bấm nút ✕ của Customily: ảnh về trống, ô file xoá giá trị
      } catch (e) {
        try { var rb = run.lockEl.querySelector('.cl_remove-image'); if (rb) rb.click(); } catch (e2) {}
      }
      UP.lastCancel = { aborted: aborted, ms: Date.now() - t0 };
      run.ended = 1; drop(run); lock(run, false);
      try { Array.prototype.forEach.call(run.host.querySelectorAll('.linhnn-uploaded-status'), function (s) { s.parentNode.removeChild(s); }); } catch (e) {}
      if (el.parentNode) el.parentNode.removeChild(el); // nút Customily đã về "Select Image" = báo huỷ xong
    })();
  }

  function onStatus(kind, node) {
    if (kind === 'photo' && aiModalOn()) return;
    var t = node.textContent || '';
    if (/just wait/i.test(t)) start(kind, node);
    else if (/ready/i.test(t)) {
      var host = kind === 'photo' ? node.parentNode : node.closest('.customily_option');
      var r = host && runFor(host);
      if (r && r.cancelled) node.classList.add('szup-hide');
      finish(host);
      if (host && doneFor(host)) node.classList.add('szup-hide');
    }
  }

  // Chặn bấm vào nút Replace/✕ của ô đang xử lý (Customily đã disabled; lớp chặn thứ 2 cho trình duyệt lạ)
  function guard(ev) {
    var t = ev.target; if (!t || !t.closest) return;
    var b = t.closest('.customily-download-button,.cl_remove-image'); if (!b) return;
    var c = b.closest('.szup-lock'); if (c && !b.classList.contains('szup-x')) { ev.preventDefault(); ev.stopImmediatePropagation(); }
  }

  // Quan sát CHỈ trong #customily-options (không quan sát body). Khối có thể bị Customily vẽ lại → kiểm 1s/lần còn gắn không.
  var root = null, mo = null, tries = 0;
  function attach() {
    var r = document.getElementById('customily-options');
    if (r === root && r && r.isConnected) return;
    if (mo) { mo.disconnect(); mo = null; }
    if (root) root.removeEventListener('click', guard, true);
    root = r; if (!r) return;
    r.addEventListener('click', guard, true);
    mo = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var a = ms[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType !== 1) continue;
          if (n.classList.contains(CFG.photo.sel)) { try { onStatus('photo', n); } catch (e) {} }
          else if (n.classList.contains(CFG.cw.sel)) { try { onStatus('cw', n); } catch (e) {} }
        }
      }
      // ô upload / ô crossword biến mất khi đang chạy (Customily vẽ lại, đổi biến thể) → dọn
      for (var k = runs.length - 1; k >= 0; k--) { var rr = runs[k]; if (!rr.el.isConnected && !rr.cancelled) stop(rr); }
      // ô đã xong: ảnh bị xoá / Customily vẽ lại (không còn dòng trạng thái LinhNN nào trong ô) → gỡ
      for (var d = dones.length - 1; d >= 0; d--) { var dd = dones[d]; if (!dd.el.isConnected || !dd.host.isConnected || !dd.host.querySelector('.' + CFG[dd.kind].sel)) undone(dd); }
    });
    mo.observe(r, { childList: true, subtree: true });
  }
  var iv = setInterval(function () { tries++; try { attach(); } catch (e) {} if (tries > 1800) clearInterval(iv); }, 1000);
  attach();
})();

